import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService, HelpersService }   from '@evento-ng/libs';
import { IUser } from 'src/app/shared/models/IUser.model';

@Component({
  selector: 'app-root-account',
  templateUrl: './root-account.component.html',
})
export class RootAccountComponent implements OnInit {
  user$: Observable<IUser>;
  active = 'personalAccount';

  constructor(
    private authService: AuthService,
    public helpers: HelpersService
  ) {}

  ngOnInit(): void {
    this.user$ = this.authService.user$.pipe(
      map((user) => {
        if (user) {
          return user;
        }
        return null;
      })
    );
  }

}
